var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.73 29.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Add Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .sh-cls1 {\n        fill: inherit;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whiteboard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "sh-cls1",
    cx: 11.55,
    cy: 11.55,
    r: 11.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "sh-cls1",
    d: "m28.97,29.64H10.56c-.42,0-.76-.34-.76-.76V10.47c0-.42.34-.76.76-.76h18.41c.42,0,.76.34.76.76v18.41c0,.42-.34.76-.76.76Zm-17.66-1.51h16.9V11.22H11.31v16.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.95b7b062cada6afcb6579faffd30e609.svg";
export { ForwardRef as ReactComponent };